import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import TocObj from './tocObj.js';

var Toc = /*#__PURE__*/function () {
  function Toc(article) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Toc);

    if (options.nullTitle === undefined) {
      options.nullTitle = '';
    }

    if (options.autoCompletion === undefined) {
      options.autoCompletion = true;
    }

    if (options.anch === undefined) {
      options.anch = true;
    }

    if (options.deep === undefined || options.deep > 6) {
      options.deep = 6;
    }

    this.options = options;
    this.headers = this._preMakeHeaders(article);

    if (options.autoCompletion) {
      this._checkHeaders(this.headers);
    } // 创建目录容器


    var ul = document.createElement('ul');
    var sectionNumbers = [0, 0, 0, 0, 0, 0];
    var tocobj = new TocObj(ul, 1, sectionNumbers, this.options); // 将 headers 推入容器

    for (var i = 0; i < this.headers.length; i++) {
      tocobj.add(this.headers[i]);
    } // 生成 TOC 元素


    this.tocEl = tocobj.el;
  }

  _createClass(Toc, [{
    key: "_preMakeHeaders",
    value: function _preMakeHeaders(article) {
      // 对header进行整理、添加锚点
      var eleArr = article.children;
      var headers = [];
      var ids = [];

      for (var i in eleArr) {
        if (eleArr[i].tagName && /H1|H2|H3|H4|H5|H6/.test(eleArr[i].tagName)) {
          headers.push(eleArr[i]); // 添加锚点

          if (this.options.anch === true) {
            var id = eleArr[i].innerHTML;

            for (var _i in ids) {
              if (id === ids[_i]) {
                id = '#' + id;
              }
            }

            ids.push(id);
            eleArr[i].setAttribute('id', id);
          }
        }
      }

      return headers;
    }
  }, {
    key: "_checkHeaders",
    value: function _checkHeaders(headers) {
      for (var i = 0; i < headers.length; i++) {
        var index = headers[i].tagName.charAt(1);

        if (i > 0) {
          var lastIndex = headers[i - 1].tagName.charAt(1);

          if (index > lastIndex && lastIndex != index && lastIndex != index - 1) {
            var emptyHeader = document.createElement("h".concat(index - 1));
            emptyHeader.innerHTML = this.options.nullTitle;
            headers.splice(i, 0, emptyHeader);
            i--;
          }
        } else {
          if (index != 1) {
            var _emptyHeader = document.createElement("h".concat(index - 1));

            _emptyHeader.innerHTML = this.options.nullTitle;
            headers.splice(i, 0, _emptyHeader);
            i--;
          }
        }
      }
    }
  }]);

  return Toc;
}();

export { Toc as default };